import { LECTURE_CONTENT_TYPES } from './lectureContentTypes';

export const LECTURE_CONTENT_OPTIONS = {
  [LECTURE_CONTENT_TYPES.preLecture]: { label: 'Pre Lecture Content' },
  [LECTURE_CONTENT_TYPES.postLecture]: { label: 'Post Lecture Content' },
  [LECTURE_CONTENT_TYPES.literatureResource]: { label: 'Research Papers' },
};
